import { INITIALIZE_SOCKET, WITHOUT_INIT_SOCKET,GET_SOCKET_CONNECTION_STATUS } from "../constants";

export const setInializeSocket = (payload) => ({
    type: INITIALIZE_SOCKET,
    payload,
});

export const withOutInitSocket = (payload) => ({
    type: WITHOUT_INIT_SOCKET,
    payload,
});

export const getSocketConnection = (payload) => ({
    type: GET_SOCKET_CONNECTION_STATUS,
    payload,
});